import { z } from "zod";

/** Россия: код 7 + 10 цифр национального номера. */
const RU_PHONE_DIGITS_PATTERN = /^7\d{10}$/;

const RU_COUNTRY_DIGIT = "7";
const RU_NATIONAL_LENGTH = 10;

export function normalizePhone(value: string): string {
  let digits = value.replace(/\D/g, "");

  if (!digits) return "";

  if (digits.length === 11 && digits.startsWith("8")) {
    digits = `${RU_COUNTRY_DIGIT}${digits.slice(1)}`;
  } else if (digits.startsWith("8")) {
    digits = `${RU_COUNTRY_DIGIT}${digits.slice(1)}`;
  } else if (
    digits.startsWith("9") &&
    digits.length <= RU_NATIONAL_LENGTH &&
    !digits.startsWith(RU_COUNTRY_DIGIT)
  ) {
    digits = `${RU_COUNTRY_DIGIT}${digits}`;
  }

  return digits;
}

function getMaskDigits(value: string): string {
  let digits = value.replace(/\D/g, "");

  if (!digits) return "";

  if (digits.length === 11 && digits.startsWith("8")) {
    digits = `${RU_COUNTRY_DIGIT}${digits.slice(1)}`;
  } else if (digits.startsWith("8")) {
    digits = `${RU_COUNTRY_DIGIT}${digits.slice(1)}`;
  } else if (
    digits.startsWith("9") &&
    digits.length <= RU_NATIONAL_LENGTH &&
    !digits.startsWith(RU_COUNTRY_DIGIT)
  ) {
    digits = `${RU_COUNTRY_DIGIT}${digits}`;
  } else if (!digits.startsWith(RU_COUNTRY_DIGIT)) {
    return "";
  }

  return digits.slice(0, 1 + RU_NATIONAL_LENGTH);
}

function formatRussianPhoneMask(digits: string): string {
  const national = digits.startsWith(RU_COUNTRY_DIGIT)
    ? digits.slice(1)
    : digits;

  let result = `+${RU_COUNTRY_DIGIT}`;

  if (!national) return result;

  result += ` (${national.slice(0, 3)}`;
  if (national.length < 3) return result;

  result += ")";
  if (national.length === 3) return result;

  result += ` ${national.slice(3, 6)}`;
  if (national.length <= 6) return result;

  result += `-${national.slice(6, 8)}`;
  if (national.length <= 8) return result;

  return `${result}-${national.slice(8, RU_NATIONAL_LENGTH)}`;
}

/** Форматирует ввод в маску +7 (999) 123-45-67. */
export function formatPhoneMask(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return "";

  const digits = getMaskDigits(value);
  if (!digits) return trimmed === "+" ? "+" : "";

  return formatRussianPhoneMask(digits);
}

export function isValidRussianPhone(digits: string): boolean {
  return RU_PHONE_DIGITS_PATTERN.test(digits);
}

export function getPhoneValidationError(value: string): string | undefined {
  const digits = normalizePhone(value);

  if (!digits) {
    return "Введите номер телефона";
  }

  if (!isValidRussianPhone(digits)) {
    return "Некорректный номер телефона";
  }

  return undefined;
}

export const internationalPhoneSchema = z
  .string()
  .min(1, "Введите номер телефона")
  .transform(normalizePhone)
  .pipe(
    z
      .string()
      .length(11, "Некорректный номер телефона")
      .regex(RU_PHONE_DIGITS_PATTERN, "Некорректный номер телефона"),
  );
